import { render, staticRenderFns } from "./store_detail.vue?vue&type=template&id=15bd01d8&scoped=true&"
import script from "./store_detail.vue?vue&type=script&lang=js&"
export * from "./store_detail.vue?vue&type=script&lang=js&"
import style0 from "./store_detail.vue?vue&type=style&index=0&id=15bd01d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bd01d8",
  null
  
)

export default component.exports